import React, { useState } from "react";
import { Table, Button, UncontrolledTooltip } from "reactstrap";
import { FormattedDate, FormattedTime } from "react-intl";
import { FormattedNumber } from "../FormattedNumber/FormattedNumber";
import style from "./ExecutionsTable.module.scss";
import { ZOOM_OUT, XS } from "react-ladda/dist/constants";
import LaddaButton from "react-ladda/dist/LaddaButton";

const ExecutionsTable = (props) => {
  return (
    <div className={style.container}>
      <Table className={style.tableFixed} responsive>
        <thead>
          <tr>
            <th>Trade/Exec</th>
            <th>Date</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Trading Route</th>
            <th>Counterparty</th>
            {/* <th style={{ width: "40px" }}></th> */}
          </tr>
        </thead>
        <tbody>
          <ExecutionsRows {...props} />
        </tbody>
      </Table>
    </div>
  );
};

const ExecutionsRows = ({ executions, decimalAmount, ...props }) => {
  const [loadings, setLoadings] = useState({});

  const onDelete = (execution) => {
    if (window.confirm(`Are you sure to delete execution #${execution.childId}?`)) {
      setLoadings({ ...loadings, [execution.childId]: true });
      props.onDelete(execution, () => {
        setLoadings({ ...loadings, [execution.childId]: false });
      });
    }
  };

  if (!executions.length) {
    return (
      <tr>
        <td colSpan="12" style={{ textAlign: "center", padding: "20px" }}>
          <h5 style={{ textAlign: "center" }}>No Executions</h5>
        </td>
      </tr>
    );
  }

  return executions.map((execution) => {
    return (
      <tr key={`execution-${execution.childId}`} className={style.executionTableRow}>
        <td>
          <span>
            <b>{execution.childId}</b> / {execution.ExecutionId}
          </span>
        </td>
        <td>
          <FormattedDate value={execution.ExecutionDate} />{" "}
          <FormattedTime
            value={execution.ExecutionDate}
            hour12={false}
            hour="numeric"
            minute="numeric"
            second="numeric"
          />
        </td>
        <td>
          <FormattedNumber
            value={execution.ExecutionQuantity}
            decimalScale={decimalAmount}
            dataTypeDecimalName="quantity"
          />
        </td>
        <td>
          <FormattedNumber
            value={execution.ExecutionPrice}
            decimalScale={decimalAmount}
            dataTypeDecimalName="price"
          />
        </td>
        <td>
          <span>{execution.TradingRouteName}</span>
        </td>
        <td>
          <span>{execution.CounterPartyName}</span>
        </td>
        <td className={style.action}>
          <ExecutionMoreInfo execution={execution} />

          {props.showDelete ? (
            execution.sent ? (
              <span className={style.icon}>
                <i className="fa fa-lock"></i>
              </span>
            ) : (
              <LaddaButton
                className="btn btn-danger btn-ladda"
                loading={loadings[execution.childId]}
                disabled={!!execution.disabled}
                onClick={() => onDelete(execution)}
                data-color="red"
                data-style={ZOOM_OUT}
                data-size={XS}
              >
                <i className={`fa fa-${execution.ExecutionIsMassive ? "unlink" : "trash-o"}`}></i>
              </LaddaButton>
            )
          ) : // <Button onClick={() => props.onDelete(execution)} color="danger" size="sm" key={`action2-exec-${execution.ExecutionId}`}>
          // 		<i className="fa fa-trash-o"></i>
          // 	</Button>
          null}
        </td>
      </tr>
    );
  });
};

const ExecutionMoreInfo = (props) => {
  return null;
  ///////////////// BUG //////////////////
  return (
    <div className={style.moreInfo}>
      <i className="icon-info icons" id={`moreinfo-${props.execution.ExecutionId}`}></i>
      <UncontrolledTooltip
        placement="right"
        target={`moreinfo-${props.execution.ExecutionId}`}
        style={{ textAlign: "left" }}
      >
        <span>Broker: </span>
        <br />
        <span>Counterparty: </span>
      </UncontrolledTooltip>
    </div>
  );
};

export default ExecutionsTable;
